// import React, { useEffect, useState } from "react";
// import { Row, Col, Input, Label, Button, Table } from "reactstrap";
// import { Formik, Form, ErrorMessage } from "formik";
// import * as Yup from "yup";
// import Flatpickr from "react-flatpickr";
// import { createSelector } from "reselect";
// import { useDispatch, useSelector } from "react-redux";
// import Select from "react-select";

// import { fetchCustomersList } from "../../../slices/thunks";
// import { fetchTaxList } from "../../../slices/TaxMaster/thunk";
// import { fetchBillInvoiceList } from "../../../slices/SalesInvoiceGST/thunk"; // TODO: swap for dedicated bill-list endpoint when ready

// const validationSchema = Yup.object({
//   customerId: Yup.string().required("Customer is required"),
//   generateBillId: Yup.string().required("Invoice/Bill is required"),
//   taxId: Yup.string().required("Tax is required"),
//   creditNoteDate: Yup.date().required("Credit note date is required"),
//   amountInclGst: Yup.number()
//     .typeError("Amount must be a number")
//     .required("Amount is required")
//     .moreThan(0, "Amount must be greater than 0"),
// });

// const GenerateCreditNoteForm = ({ onSubmit, onCloseForm }) => {
//   const dispatch = useDispatch();

//   const [totals, setTotals] = useState({
//     taxableAmount: 0,
//     cgst: 0,
//     sgst: 0,
//     igst: 0,
//     totalGst: 0,
//     grandTotal: 0,
//   });

//   const selector = createSelector(
//     (state) => state,
//     (state) => ({
//       taxes: state.TaxMaster.taxes,
//       customersList: state.Customer.customers,
//       bills: state.SalesInvoice.billInvoices,
//       billsLoading: state.SalesInvoice.loading,
//       activeSessions: state.Session.selectedSessionYear,
//     }),
//   );

//   const { taxes, customersList, bills, billsLoading, activeSessions } =
//     useSelector(selector);

//   useEffect(() => {
//     dispatch(fetchTaxList({ isPagination: 0 }));
//     dispatch(fetchCustomersList({ isPagination: 0 }));
//   }, [dispatch]);

//   const taxOptions = (taxList) =>
//     (taxList || []).map((t) => ({
//       label: `${t.name?.toUpperCase()} (${t.taxType})`,
//       value: t.id,
//     }));

//   // REVERSE CALCULATION
//   // User enters amount INCLUSIVE of GST -> first strip out the extra
//   // charges (toll/other/handling), then back out taxable amount, cgst,
//   // sgst from what's left. Charges are added back on top at the end so
//   // the Grand Total = taxable amount + GST + charges.
//   const calculateTotals = (
//     amountInclGst = 0,
//     selectedTaxId = "",
//     extraCharges = 0,
//   ) => {
//     const enteredAmount = Number(amountInclGst) || 0;
//     const charges = Number(extraCharges) || 0;

//     // amount left to reverse-calculate GST on, after removing charges
//     const amountAfterCharges = enteredAmount - charges;

//     const selectedTax = taxes.find((t) => t.id === selectedTaxId);

//     let cgstRate = 0,
//       sgstRate = 0;

//     if (selectedTax?.taxType === "C&SGST") {
//       cgstRate = Number(selectedTax.cgst || 0);
//       sgstRate = Number(selectedTax.sgst || 0);
//     }
//     // IGST intentionally ignored for now

//     const totalRate = cgstRate + sgstRate; // e.g. 9 + 9 = 18
//     const taxableAmount =
//       totalRate > 0
//         ? amountAfterCharges / (1 + totalRate / 100)
//         : amountAfterCharges;

//     const cgst = (taxableAmount * cgstRate) / 100;
//     const sgst = (taxableAmount * sgstRate) / 100;
//     const totalGst = cgst + sgst;

//     // Grand Total = taxable amount + GST + charges added back
//     const grandTotal = taxableAmount + totalGst + charges;

//     const result = {
//       taxableAmount,
//       cgst,
//       sgst,
//       igst: 0,
//       totalGst,
//       charges,
//       grandTotal,
//     };

//     setTotals(result);
//     return result;
//   };

//   // helper — sum of the three display charges pulled from the bill
//   const getExtraCharges = (values) =>
//     (Number(values.tollCharges) || 0) +
//     (Number(values.otherCharges) || 0) +
//     (Number(values.handlingCharges) || 0);

//   const formatDate = (d) => {
//     if (!d) return "";
//     const dt = new Date(d);
//     const y = dt.getFullYear();
//     const m = String(dt.getMonth() + 1).padStart(2, "0");
//     const day = String(dt.getDate()).padStart(2, "0");
//     return `${day}-${m}-${y}`;
//   };

//   return (
//     <div className="p-3">
//       <Formik
//         initialValues={{
//           sessionId: activeSessions?.id || "",
//           customerId: "",
//           generateBillId: "",
//           taxId: "",
//           creditNoteDate: new Date(),
//           invoiceAmount: 0,
//           amountInclGst: "",
//           note: "",
//           // extra charges pulled from the selected bill; subtracted from
//           // amountInclGst before the GST reverse-calc, then added back
//           // into Grand Total (see calculateTotals)
//           tollCharges: 0,
//           otherCharges: 0,
//           handlingCharges: 0,
//         }}
//         validationSchema={validationSchema}
//         onSubmit={(values, { resetForm }) => {
//           const payload = {
//             sessionId: values.sessionId || activeSessions?.id || null,
//             taxId: values.taxId,
//             taxPerc: taxes.find((t) => t.id === values.taxId)?.taxPerc || 0,
//             creditNoteDate: formatDate(values.creditNoteDate),
//             customerId: values.customerId,
//             generateBillId: values.generateBillId,
//             invoiceAmount: Number(values.invoiceAmount || 0),
//             creditNoteAmount: Number(totals.taxableAmount.toFixed(2)), // taxable amount (pre-GST)
//             cgst: Number(totals.cgst.toFixed(2)),
//             sgst: Number(totals.sgst.toFixed(2)),
//             igst: Number(totals.igst || 0),
//             totalGst: Number(totals.totalGst.toFixed(2)),
//             grandTotal: Number(totals.grandTotal.toFixed(2)), // taxable + GST + charges
//             note: values.note || "",
//           };

//           if (onSubmit) onSubmit(payload);
//           resetForm();
//           onCloseForm();
//         }}
//       >
//         {({ values, setFieldValue }) => (
//           <Form>
//             <Row className="g-4">
//               {/* Session (readonly) */}
//               <Col md={3}>
//                 <div>
//                   <label className="form-label">Session *</label>

//                   {activeSessions &&
//                     values.sessionId !== activeSessions?.id &&
//                     setFieldValue("sessionId", activeSessions?.id)}

//                   <input
//                     type="text"
//                     className="form-control"
//                     value={activeSessions?.name || ""}
//                     disabled
//                   />
//                   <input
//                     type="hidden"
//                     name="sessionId"
//                     value={values.sessionId}
//                   />
//                 </div>
//               </Col>

//               {/* Customer */}
//               <Col md={3}>
//                 <Label>
//                   Customer <span className="text-danger">*</span>
//                 </Label>
//                 <Select
//                   options={customersList?.map((c) => ({
//                     value: c.id,
//                     label: c.name,
//                   }))}
//                   value={
//                     values.customerId
//                       ? {
//                           value: values.customerId,
//                           label: customersList.find(
//                             (c) => c.id === values.customerId,
//                           )?.name,
//                         }
//                       : null
//                   }
//                   onChange={(opt) => {
//                     setFieldValue("customerId", opt?.value || "");

//                     setFieldValue("generateBillId", "");
//                     setFieldValue("invoiceAmount", 0);
//                     setFieldValue("amountInclGst", "");
//                     setFieldValue("tollCharges", 0);
//                     setFieldValue("otherCharges", 0);
//                     setFieldValue("handlingCharges", 0);
//                     calculateTotals(0, values.taxId, 0);

//                     if (opt?.value) {
//                       dispatch(
//                         fetchBillInvoiceList({
//                           customerId: opt.value,
//                           sessionId: values.sessionId,
//                           isPagination: 0,
//                           isCreditNote: false,

//                           sortBy: "createdAt",
//                           sortOrder: "DESC",
//                         }),
//                       );
//                     }
//                   }}
//                   placeholder="Select Customer"
//                 />
//                 <ErrorMessage
//                   name="customerId"
//                   component="div"
//                   className="text-danger small"
//                 />
//               </Col>

//               {/* Bill / Invoice */}
//               <Col md={3}>
//                 <Label>
//                   Invoice / Bill <span className="text-danger">*</span>
//                 </Label>
//                 <Select
//                   options={bills?.map((b) => ({
//                     value: b.id,
//                     label: b.invoiceNo,
//                     grandTotal: b.grandTotal,
//                   }))}
//                   isLoading={billsLoading}
//                   isDisabled={!values.customerId}
//                   value={
//                     values.generateBillId
//                       ? {
//                           value: values.generateBillId,
//                           label: bills.find(
//                             (b) => b.id === values.generateBillId,
//                           )?.invoiceNo,
//                         }
//                       : null
//                   }
//                   onChange={(opt) => {
//                     setFieldValue("generateBillId", opt?.value || "");

//                     const selectedBill = bills.find((b) => b.id === opt?.value);
//                     const invoiceAmount = selectedBill?.grandTotal || 0;

//                     setFieldValue("invoiceAmount", invoiceAmount);

//                     // Initially set Amount (Incl. GST) same as Invoice Amount.
//                     // It stays editable — user can change it afterwards.
//                     setFieldValue("amountInclGst", invoiceAmount);

//                     // Extra charges from the selected bill — shown in the
//                     // summary AND subtracted from the entered amount before
//                     // the GST reverse calculation, then added back into
//                     // the Grand Total.
//                     const tollCharges = selectedBill?.tollCharges || 0;
//                     const otherCharges = selectedBill?.otherCharges || 0;
//                     const handlingCharges = selectedBill?.handlingCharges || 0;

//                     setFieldValue("tollCharges", tollCharges);
//                     setFieldValue("otherCharges", otherCharges);
//                     setFieldValue("handlingCharges", handlingCharges);

//                     // Run the calculation immediately using the
//                     // auto-filled amount so totals are correct on load.
//                     calculateTotals(
//                       invoiceAmount,
//                       values.taxId,
//                       tollCharges + otherCharges + handlingCharges,
//                     );
//                   }}
//                   placeholder="Select Invoice"
//                 />
//                 <ErrorMessage
//                   name="generateBillId"
//                   component="div"
//                   className="text-danger small"
//                 />
//               </Col>

//               {/* Invoice Amount (read-only reference) */}
//               <Col md={3}>
//                 <Label>Invoice Amount</Label>
//                 <Input
//                   type="text"
//                   value={`₹ ${Number(values.invoiceAmount || 0).toFixed(2)}`}
//                   disabled
//                 />
//               </Col>

//               {/* Credit Note Date */}
//               <Col md={3}>
//                 <Label>
//                   Credit Note Date <span className="text-danger">*</span>
//                 </Label>
//                 <Flatpickr
//                   className="form-control"
//                   placeholder="dd-mm-yyyy"
//                   value={values.creditNoteDate}
//                   options={{
//                     defaultDate: new Date(),
//                     dateFormat: "d-m-Y",
//                     allowInput: true,
//                   }}
//                   onChange={(selectedDates, dateStr) => {
//                     if (selectedDates.length > 0) {
//                       setFieldValue("creditNoteDate", selectedDates[0]);
//                     } else {
//                       setFieldValue("creditNoteDate", dateStr);
//                     }
//                   }}
//                 />
//                 <ErrorMessage
//                   name="creditNoteDate"
//                   component="div"
//                   className="text-danger small"
//                 />
//               </Col>

//               {/* Tax */}
//               <Col md={3}>
//                 <Label>
//                   Tax <span className="text-danger">*</span>
//                 </Label>
//                 <Select
//                   options={taxOptions(taxes)}
//                   value={
//                     values.taxId
//                       ? {
//                           value: values.taxId,
//                           label:
//                             taxes.find((t) => t.id === values.taxId)?.name +
//                             ` (${
//                               taxes.find((t) => t.id === values.taxId)?.taxType
//                             })`,
//                         }
//                       : null
//                   }
//                   onChange={(opt) => {
//                     const newTaxId = opt?.value || "";
//                     setFieldValue("taxId", newTaxId);
//                     calculateTotals(
//                       values.amountInclGst,
//                       newTaxId,
//                       getExtraCharges(values),
//                     );
//                   }}
//                   placeholder="Select Tax"
//                 />
//                 <ErrorMessage
//                   name="taxId"
//                   component="div"
//                   className="text-danger small"
//                 />
//               </Col>

//               {/* Amount inclusive of GST — drives reverse calculation */}
//               <Col md={3}>
//                 <Label>
//                   Amount (Incl. GST) <span className="text-danger">*</span>
//                 </Label>
//                 <Input
//                   type="number"
//                   min="0"
//                   step="0.01"
//                   value={values.amountInclGst}
//                   onChange={(e) => {
//                     const val = e.target.value;
//                     setFieldValue("amountInclGst", val);
//                     calculateTotals(val, values.taxId, getExtraCharges(values));
//                   }}
//                   placeholder="Enter amount including GST"
//                 />
//                 <ErrorMessage
//                   name="amountInclGst"
//                   component="div"
//                   className="text-danger small"
//                 />
//               </Col>

//               {/* Note */}
//               <Col md={3}>
//                 <Label>Note</Label>
//                 <Input
//                   type="text"
//                   value={values.note}
//                   onChange={(e) => setFieldValue("note", e.target.value)}
//                   placeholder="Enter note"
//                 />
//               </Col>

//               {/* SUMMARY */}
//               <Col md={12} className="mt-3">
//                 <h5 className="mb-2">Credit Note Summary</h5>

//                 <Table bordered>
//                   <thead>
//                     <tr>
//                       <th>Taxable Amount</th>
//                       {values.invoiceAmount ? (
//                         <>
//                           <th>Toll Charges</th>
//                           <th>Other Charges</th>
//                           <th>Handling Charges</th>
//                         </>
//                       ) : null}

//                       {(() => {
//                         const selectedTax = taxes.find(
//                           (t) => t.id === values.taxId,
//                         );
//                         if (selectedTax?.taxType === "C&SGST") {
//                           return (
//                             <>
//                               <th>CGST ({selectedTax.cgst}%)</th>
//                               <th>SGST ({selectedTax.sgst}%)</th>
//                             </>
//                           );
//                         }
//                         return null;
//                       })()}

//                       <th>Total GST</th>
//                       <th>Grand Total</th>

//                       {/* Extra charges: subtracted from the entered amount
//                           before the GST reverse calc, then added back into
//                           Grand Total. Shown here for reference, only when
//                           an invoice amount is present. */}
//                     </tr>
//                   </thead>

//                   <tbody>
//                     <tr>
//                       <td>₹ {Number(totals.taxableAmount || 0).toFixed(2)}</td>
//                       {values.invoiceAmount ? (
//                         <>
//                           <td>
//                             ₹ {Number(values.tollCharges || 0).toFixed(2)}
//                           </td>
//                           <td>
//                             ₹ {Number(values.otherCharges || 0).toFixed(2)}
//                           </td>
//                           <td>
//                             ₹ {Number(values.handlingCharges || 0).toFixed(2)}
//                           </td>
//                         </>
//                       ) : null}

//                       {(() => {
//                         const selectedTax = taxes.find(
//                           (t) => t.id === values.taxId,
//                         );
//                         if (selectedTax?.taxType === "C&SGST") {
//                           return (
//                             <>
//                               <td>₹ {Number(totals.cgst || 0).toFixed(2)}</td>
//                               <td>₹ {Number(totals.sgst || 0).toFixed(2)}</td>
//                             </>
//                           );
//                         }
//                         return null;
//                       })()}

//                       <td>
//                         <b>₹ {Number(totals.totalGst || 0).toFixed(2)}</b>
//                       </td>
//                       <td>
//                         <b>₹ {Number(totals.grandTotal || 0).toFixed(2)}</b>
//                       </td>

//                       {/* Extra charges — already netted into Grand Total above */}
//                     </tr>
//                   </tbody>
//                 </Table>
//               </Col>

//               {/* SUBMIT */}
//               <Col md={12} className="text-end">
//                 <Button color="success" className="btn-sm" type="submit">
//                   Generate Credit Note
//                 </Button>
//               </Col>
//             </Row>
//           </Form>
//         )}
//       </Formik>
//     </div>
//   );
// };

// export default GenerateCreditNoteForm;

import React, { useEffect, useState } from "react";
import { Row, Col, Input, Label, Button, Table } from "reactstrap";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import Flatpickr from "react-flatpickr";
import { createSelector } from "reselect";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";

import { fetchCustomersList } from "../../../slices/thunks";
import { fetchTaxList } from "../../../slices/TaxMaster/thunk";
import { fetchBillInvoiceList } from "../../../slices/SalesInvoiceGST/thunk"; // TODO: swap for dedicated bill-list endpoint when ready

const validationSchema = Yup.object({
  customerId: Yup.string().required("Customer is required"),
  generateBillId: Yup.string().required("Invoice/Bill is required"),
  taxId: Yup.string().required("Tax is required"),
  creditNoteDate: Yup.date().required("Credit note date is required"),
  amountInclGst: Yup.number()
    .typeError("Amount must be a number")
    .required("Amount is required")
    .moreThan(0, "Amount must be greater than 0"),
});

const GenerateCreditNoteForm = ({ onSubmit, onCloseForm }) => {
  const dispatch = useDispatch();

  const [totals, setTotals] = useState({
    taxableAmount: 0,
    cgst: 0,
    sgst: 0,
    igst: 0,
    totalGst: 0,
    grandTotal: 0,
  });

  const selector = createSelector(
    (state) => state,
    (state) => ({
      taxes: state.TaxMaster.taxes,
      customersList: state.Customer.customers,
      bills: state.SalesInvoice.billInvoices,
      billsLoading: state.SalesInvoice.loading,
      activeSessions: state.Session.selectedSessionYear,
    }),
  );

  const { taxes, customersList, bills, billsLoading, activeSessions } =
    useSelector(selector);

  useEffect(() => {
    dispatch(fetchTaxList({ isPagination: 0 }));
    dispatch(fetchCustomersList({ isPagination: 0 }));
  }, [dispatch]);

  const taxOptions = (taxList) =>
    (taxList || []).map((t) => ({
      label: `${t.name?.toUpperCase()} (${t.taxType})`,
      value: t.id,
    }));

  const roundDown = (value) =>
    Math.floor((Number(value) + Number.EPSILON) * 100) / 100;

  // REVERSE CALCULATION
  // User enters amount INCLUSIVE of GST -> first strip out the extra
  // charges (toll/other/handling), then back out taxable amount, cgst,
  // sgst from what's left. Charges are added back on top at the end so
  // the Grand Total = taxable amount + GST + charges.
  const calculateTotals = (
    amountInclGst = 0,
    selectedTaxId = "",
    extraCharges = 0,
  ) => {
    const enteredAmount = Number(amountInclGst) || 0;
    const charges = Number(extraCharges) || 0;

    // amount left to reverse-calculate GST on, after removing charges
    const amountAfterCharges = enteredAmount - charges;

    const selectedTax = taxes.find((t) => t.id === selectedTaxId);

    let cgstRate = 0,
      sgstRate = 0;

    if (selectedTax?.taxType === "C&SGST") {
      cgstRate = Number(selectedTax.cgst || 0);
      sgstRate = Number(selectedTax.sgst || 0);
    }
    // IGST intentionally ignored for now

    const totalRate = cgstRate + sgstRate; // e.g. 9 + 9 = 18
    const rawTaxableAmount =
      totalRate > 0
        ? amountAfterCharges / (1 + totalRate / 100)
        : amountAfterCharges;

    // Round each displayed component FIRST, then derive totals from the
    // rounded values. Otherwise the rows shown on screen (each rounded
    // independently via toFixed(2)) don't add up to Grand Total, since
    // Grand Total was being computed from the raw, unrounded numbers.
    const taxableAmount = roundDown(rawTaxableAmount);
    const cgst = Number(((taxableAmount * cgstRate) / 100).toFixed(2));
    const sgst = Number(((taxableAmount * sgstRate) / 100).toFixed(2));
    const totalGst = Number((cgst + sgst).toFixed(2));

    // Grand Total = taxable amount + GST + charges added back
    const grandTotal = Number((taxableAmount + totalGst + charges).toFixed(2));

    const result = {
      taxableAmount,
      cgst,
      sgst,
      igst: 0,
      totalGst,
      charges,
      grandTotal,
    };

    setTotals(result);
    return result;
  };

  // helper — sum of the three display charges pulled from the bill
  const getExtraCharges = (values) =>
    (Number(values.tollCharges) || 0) +
    (Number(values.otherCharges) || 0) +
    (Number(values.handlingCharges) || 0);

  const formatDate = (d) => {
    if (!d) return "";
    const dt = new Date(d);
    const y = dt.getFullYear();
    const m = String(dt.getMonth() + 1).padStart(2, "0");
    const day = String(dt.getDate()).padStart(2, "0");
    return `${day}-${m}-${y}`;
  };

  return (
    <div className="p-3">
      <Formik
        initialValues={{
          sessionId: activeSessions?.id || "",
          customerId: "",
          generateBillId: "",
          taxId: "",
          creditNoteDate: new Date(),
          invoiceAmount: 0,
          amountInclGst: "",
          note: "",
          // extra charges pulled from the selected bill; subtracted from
          // amountInclGst before the GST reverse-calc, then added back
          // into Grand Total (see calculateTotals)
          tollCharges: 0,
          otherCharges: 0,
          handlingCharges: 0,
        }}
        validationSchema={validationSchema}
        onSubmit={(values, { resetForm }) => {
          const payload = {
            sessionId: values.sessionId || activeSessions?.id || null,
            taxId: values.taxId,
            taxPerc: taxes.find((t) => t.id === values.taxId)?.taxPerc || 0,
            creditNoteDate: formatDate(values.creditNoteDate),
            customerId: values.customerId,
            generateBillId: values.generateBillId,
            invoiceAmount: Number(values.invoiceAmount || 0),
            creditNoteAmount: Number(totals.taxableAmount.toFixed(2)), // taxable amount (pre-GST)
            cgst: Number(totals.cgst.toFixed(2)),
            sgst: Number(totals.sgst.toFixed(2)),
            igst: Number(totals.igst || 0),
            totalGst: Number(totals.totalGst.toFixed(2)),
            grandTotal: Number(totals.grandTotal.toFixed(2)), // taxable + GST + charges
            note: values.note || "",
          };

          if (onSubmit) onSubmit(payload);
          resetForm();
          onCloseForm();
        }}
      >
        {({ values, setFieldValue }) => (
          <Form>
            <Row className="g-4">
              {/* Session (readonly) */}
              <Col md={3}>
                <div>
                  <label className="form-label">Session *</label>

                  {activeSessions &&
                    values.sessionId !== activeSessions?.id &&
                    setFieldValue("sessionId", activeSessions?.id)}

                  <input
                    type="text"
                    className="form-control"
                    value={activeSessions?.name || ""}
                    disabled
                  />
                  <input
                    type="hidden"
                    name="sessionId"
                    value={values.sessionId}
                  />
                </div>
              </Col>

              {/* Customer */}
              <Col md={3}>
                <Label>
                  Customer <span className="text-danger">*</span>
                </Label>
                <Select
                  options={customersList?.map((c) => ({
                    value: c.id,
                    label: c.name,
                  }))}
                  value={
                    values.customerId
                      ? {
                          value: values.customerId,
                          label: customersList.find(
                            (c) => c.id === values.customerId,
                          )?.name,
                        }
                      : null
                  }
                  onChange={(opt) => {
                    setFieldValue("customerId", opt?.value || "");

                    setFieldValue("generateBillId", "");
                    setFieldValue("invoiceAmount", 0);
                    setFieldValue("amountInclGst", "");
                    setFieldValue("tollCharges", 0);
                    setFieldValue("otherCharges", 0);
                    setFieldValue("handlingCharges", 0);
                    calculateTotals(0, values.taxId, 0);

                    if (opt?.value) {
                      dispatch(
                        fetchBillInvoiceList({
                          customerId: opt.value,
                          sessionId: values.sessionId,
                          isPagination: 0,
                          isCreditNote: false,
                          sortBy: "createdAt",
                          sortOrder: "DESC",
                        }),
                      );
                    }
                  }}
                  placeholder="Select Customer"
                />
                <ErrorMessage
                  name="customerId"
                  component="div"
                  className="text-danger small"
                />
              </Col>

              {/* Bill / Invoice */}
              <Col md={3}>
                <Label>
                  Invoice / Bill <span className="text-danger">*</span>
                </Label>
                <Select
                  options={bills?.map((b) => ({
                    value: b.id,
                    label: b.invoiceNo,
                    grandTotal: b.grandTotal,
                  }))}
                  isLoading={billsLoading}
                  isDisabled={!values.customerId}
                  value={
                    values.generateBillId
                      ? {
                          value: values.generateBillId,
                          label: bills.find(
                            (b) => b.id === values.generateBillId,
                          )?.invoiceNo,
                        }
                      : null
                  }
                  onChange={(opt) => {
                    setFieldValue("generateBillId", opt?.value || "");

                    const selectedBill = bills.find((b) => b.id === opt?.value);
                    const invoiceAmount = selectedBill?.grandTotal || 0;

                    setFieldValue("invoiceAmount", invoiceAmount);

                    // Initially set Amount (Incl. GST) same as Invoice Amount.
                    // It stays editable — user can change it afterwards.
                    setFieldValue("amountInclGst", invoiceAmount);

                    // Extra charges from the selected bill — shown in the
                    // summary AND subtracted from the entered amount before
                    // the GST reverse calculation, then added back into
                    // the Grand Total.
                    const tollCharges = selectedBill?.tollCharges || 0;
                    const otherCharges = selectedBill?.otherCharges || 0;
                    const handlingCharges = selectedBill?.handlingCharges || 0;

                    setFieldValue("tollCharges", tollCharges);
                    setFieldValue("otherCharges", otherCharges);
                    setFieldValue("handlingCharges", handlingCharges);

                    // Run the calculation immediately using the
                    // auto-filled amount so totals are correct on load.
                    calculateTotals(
                      invoiceAmount,
                      values.taxId,
                      tollCharges + otherCharges + handlingCharges,
                    );
                  }}
                  placeholder="Select Invoice"
                />
                <ErrorMessage
                  name="generateBillId"
                  component="div"
                  className="text-danger small"
                />
              </Col>

              {/* Invoice Amount (read-only reference) */}
              <Col md={3}>
                <Label>Invoice Amount</Label>
                <Input
                  type="text"
                  value={`₹ ${Number(values.invoiceAmount || 0).toFixed(2)}`}
                  disabled
                />
              </Col>

              {/* Credit Note Date */}
              <Col md={3}>
                <Label>
                  Credit Note Date <span className="text-danger">*</span>
                </Label>
                <Flatpickr
                  className="form-control"
                  placeholder="dd-mm-yyyy"
                  value={values.creditNoteDate}
                  options={{
                    defaultDate: new Date(),
                    dateFormat: "d-m-Y",
                    allowInput: true,
                  }}
                  onChange={(selectedDates, dateStr) => {
                    if (selectedDates.length > 0) {
                      setFieldValue("creditNoteDate", selectedDates[0]);
                    } else {
                      setFieldValue("creditNoteDate", dateStr);
                    }
                  }}
                />
                <ErrorMessage
                  name="creditNoteDate"
                  component="div"
                  className="text-danger small"
                />
              </Col>

              {/* Tax */}
              <Col md={3}>
                <Label>
                  Tax <span className="text-danger">*</span>
                </Label>
                <Select
                  options={taxOptions(taxes)}
                  value={
                    values.taxId
                      ? {
                          value: values.taxId,
                          label:
                            taxes.find((t) => t.id === values.taxId)?.name +
                            ` (${
                              taxes.find((t) => t.id === values.taxId)?.taxType
                            })`,
                        }
                      : null
                  }
                  onChange={(opt) => {
                    const newTaxId = opt?.value || "";
                    setFieldValue("taxId", newTaxId);
                    calculateTotals(
                      values.amountInclGst,
                      newTaxId,
                      getExtraCharges(values),
                    );
                  }}
                  placeholder="Select Tax"
                />
                <ErrorMessage
                  name="taxId"
                  component="div"
                  className="text-danger small"
                />
              </Col>

              {/* Amount inclusive of GST — drives reverse calculation */}
              <Col md={3}>
                <Label>
                  Amount (Incl. GST) <span className="text-danger">*</span>
                </Label>
                <Input
                  type="number"
                  min="0"
                  step="0.01"
                  value={values.amountInclGst}
                  onChange={(e) => {
                    const val = e.target.value;
                    setFieldValue("amountInclGst", val);
                    calculateTotals(val, values.taxId, getExtraCharges(values));
                  }}
                  placeholder="Enter amount including GST"
                />
                <ErrorMessage
                  name="amountInclGst"
                  component="div"
                  className="text-danger small"
                />
              </Col>

              {/* Note */}
              <Col md={3}>
                <Label>Note</Label>
                <Input
                  type="text"
                  value={values.note}
                  onChange={(e) => setFieldValue("note", e.target.value)}
                  placeholder="Enter note"
                />
              </Col>

              {/* SUMMARY */}
              <Col md={12} className="mt-3">
                <h5 className="mb-2">
                  Credit Note Summary (Reverse Calculated)
                </h5>

                <Table bordered>
                  <thead>
                    <tr>
                      <th>Taxable Amount</th>
                      {values.invoiceAmount ? (
                        <>
                          <th>Toll Charges</th>
                          <th>Other Charges</th>
                          <th>Handling Charges</th>
                        </>
                      ) : null}

                      {(() => {
                        const selectedTax = taxes.find(
                          (t) => t.id === values.taxId,
                        );
                        if (selectedTax?.taxType === "C&SGST") {
                          return (
                            <>
                              <th>CGST ({selectedTax.cgst}%)</th>
                              <th>SGST ({selectedTax.sgst}%)</th>
                            </>
                          );
                        }
                        return null;
                      })()}

                      <th>Total GST</th>
                      <th>Grand Total</th>

                      {/* Extra charges: subtracted from the entered amount
                          before the GST reverse calc, then added back into
                          Grand Total. Shown here for reference, only when
                          an invoice amount is present. */}
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td>₹ {Number(totals.taxableAmount || 0).toFixed(2)}</td>

                      {values.invoiceAmount ? (
                        <>
                          <td>
                            ₹ {Number(values.tollCharges || 0).toFixed(2)}
                          </td>
                          <td>
                            ₹ {Number(values.otherCharges || 0).toFixed(2)}
                          </td>
                          <td>
                            ₹ {Number(values.handlingCharges || 0).toFixed(2)}
                          </td>
                        </>
                      ) : null}

                      {(() => {
                        const selectedTax = taxes.find(
                          (t) => t.id === values.taxId,
                        );
                        if (selectedTax?.taxType === "C&SGST") {
                          return (
                            <>
                              <td>₹ {Number(totals.cgst || 0).toFixed(2)}</td>
                              <td>₹ {Number(totals.sgst || 0).toFixed(2)}</td>
                            </>
                          );
                        }
                        return null;
                      })()}

                      <td>
                        <b>₹ {Number(totals.totalGst || 0).toFixed(2)}</b>
                      </td>
                      <td>
                        <b>₹ {Number(totals.grandTotal || 0).toFixed(2)}</b>
                      </td>

                      {/* Extra charges — already netted into Grand Total above */}
                    </tr>
                  </tbody>
                </Table>
              </Col>

              {/* SUBMIT */}
              <Col md={12} className="text-end">
                <Button color="success" className="btn-sm" type="submit">
                  Generate Credit Note
                </Button>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default GenerateCreditNoteForm;
